
export const wa = require("./icon/whatsapp48.png");
export const emptyroom =
  "https://st.depositphotos.com/1047404/1878/i/950/depositphotos_18782653-stock-photo-empty-brown-room.jpg";

export const logo = require("./icon/logo.jpg");

const slider1 = require("./slider/wecoffee.webp");
const slider2 = require("./slider/Advance1.webp");
const slider3 = require("./slider/IMONO1.webp");
const slider4 = require("./slider/LIVING-RESIDENTIAL.jpg");
const slider5 = require("./slider/EVENT-JKT-FAIR.jpg");

let b = "./booth/"
export const listBooth = [
  { img: require(b+"acer.jpg"), title: "Acer" },
  { img: require(b+"commercialspace.jpg"), title: "booth Space" },
  { img: require(b+"hyundai.jpg"), title: "Hyundai" },
  { img: require(b+"manulife.jpg"), title: "Manulife" },
  { img: require(b+"mrt_jakarta.jpg"), title: "MRT Jakarta" },
  { img: require(b+"omron.jpg"), title: "OMRON" },
  { img: require(b+"thermindo.jpg"), title: "Thermindo " },
  { img: require(b+"toso.jpg"), title: "Toso" },
  { img: require(b+"trakindo.jpg"), title: "Trakindo" }
];

let c = "./commercial/"
export const mnc = [
  { img: require(c+"mnclobby1.jpg"), title: "MNC Lobby 1" },
  { img: require(c+"mnclobby2.jpg"), title: "MNC Lobby 2" },
  { img: require(c+"mnclobby3.jpg"), title: "MNC Lobby 3" },
  { img: require(c+"mncmeeting.jpg"), title: "MNC Meeting Room" },
]

export const listCommercial = [
  { img: require(c+"jjlapp.jpg"),title: "JJ Lapp Cable" },
  { img: require(c+"palembanghotel.jpg"),title: "Palembang Hotel Lounge" },
]

let r = "./residential/"
export const listResidential = [
  { img: require(r+"living.jpg"), title: "Living Room" },
  { img: require(r+"dining.jpg"), title: "Dining Room" },
  { img: require(r+"sahid.jpg"), title: "Sahid Sudirman Apartment" },
  { img: require(r+"japan.jpg"), title: "" },
  { img: require(r+"japan2.jpg"), title: "" },
];


let aeon = "./counter/aeontjbarat/"
export const aeontjbarat = [
  { img: require(aeon + "1.jpg") },
  { img: require(aeon + "2.jpg") },
  { img: require(aeon + "3.jpg") },
];

export const listfair = [
  { img: require("./counter/advance1.jpg") },
];

let bb = './counter/bunnybellegramedCP/'
export const bbelle = [
  { img: require(bb + "1.jpg") },
  { img: require(bb + "2.jpg") },
]

let er = './counter/easyrent/' //easy rent 2019
export const easyrent = [
  { img: require(er + "1.jpg") },
  { img: require(er + "2.jpg") },
]

let jkf = "./counter/jakartafair/"
export const PRJjakartafair = [
  { img: require(jkf +"1.jpg"), title:"Jakarta Fair 2017" },
  { img: require(jkf +"2.jpg"), title:"Jakarta Fair 2017"},
  { img: require(jkf +"3.jpg"), title:"Jakarta Fair 2018"},
  { img: require(jkf +"4.jpg"), title:"Jakarta Fair 2019"},
  { img: require(jkf +"5.jpg"), title:"Jakarta Fair 2019"},
]

export const livingworld = [
  { img: require("./counter/livingworld/1.jpeg") },
  { img: require("./counter/livingworld/2.jpeg") },
]

export const sialinterfood = [
  { img: require("./counter/SIALinterfood/1.jpg") },
]

export const showroom = [
  { img: require("./counter/showroom/1.jpg") },
  { img: require("./counter/showroom/2.jpg") },
  { img: require("./counter/showroom/3.jpg") },
  { img: require("./counter/showroom/4.jpg") },
  { img: require("./counter/showroom/5.jpg") },
]


let wec = "./counter/wecoffee/"
export const wecoffee = [
  { img: require(wec + "0.webp") },
  { img: require(wec + "1.jpg") },
  { img: require(wec + "2.jpg") },
  { img: require(wec + "3.jpg") },
  { img: require(wec + "4real.jpg") },
  { img: require(wec + "5real.jpg") },
];


export const sliderimg = [
  {
    img: slider1,
    title: `Counter : "we coffee" Project`,
    link: `wecoffee`,
    desc: `inDesign CREATION : "We Coffee" Project `,

    btnCaption: "Our Projects",
  },
  {
    img: slider2,
    title: `Booth : PT. Advance Project`,
    link: `advance`,
    desc: "inDesign Counter : PT. Advance",
  },
  {
    img: slider3,
    title: `Booth : IMONO Project`,
    link: `imono`,
    desc: `inDesign Counter : IMONO`,
  },
  {
    img: slider4,
    title: `Concept : Residential Design`,
    link: `residential`,
    desc: "inDesign Concept: Residential Design",
  },
  {
    img: slider5,
    title: `Booth : PRJ Jakarta Fair `,
    link: `advance_jakarta_fair`,
    desc: "inDesign Project : Advance PRJ Jakarta Fair",
  },
];

